<template>
  <div>
      <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Contractors</h3>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="handleClickCreateContractorButton">Create</v-btn>
      </v-card-title>
      <v-card-text>
        <table class="v-table theme--light">
          <thead>
          <tr>
            <th class="column text-xs-left">Title</th>
            <th class="column text-xs-left">Address</th>
            <th class="column text-xs-left">Phone</th>
            <th class="column text-xs-left">Email</th>
            <th class="column text-xs-left">Responsible Person</th>
            <th class="column text-xs-left">Material Type</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <contractor-item v-for="item in items"
                               v-bind:key="item.id"
                               v-bind:item="item"
                               @editContractor="handleContractorEditEvent">
          </contractor-item>
          <tr v-if="items.length === 0">
            <td colspan="7" class="text-sm-center">No available contractors</td>
          </tr>
          </tbody>
        </table>
        <v-flex d-block xs6>
          <contractor-form
            :visible="contractorFormVisible"
            :selectedContractorItem="selectedContractorItem"
            @close="handleCreationFormCloseEvent"></contractor-form>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-flex>
    <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Contractors Details</h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-container fluid :style="{'padding-top': 0}">
          <v-layout>
          <v-flex xs4 md4 class="ml-3">
            <v-select
              :items="items"
              v-model="selectedContractorId"
              :disabled="(selectedServiceId || selectedClientId) ? true : false"
              item-text="title"
              item-value="id"
              no-data-text="No contractors"
              label="Contractors"
              clearable
              @change="handleFilterChanged"
            />
          </v-flex>
          <v-flex xs4 md4 class="ml-3">
            <v-select
              :items="availableServices"
              v-model="selectedServiceId"
              :disabled="(selectedClientId || selectedContractorId) ? true : false"
              item-text="title"
              item-value="id"
              no-data-text="No services"
              label="Services"
              clearable
              @change="handleFilterChanged"
            />
          </v-flex>
          <v-flex xs4 md4 class="ml-3">
            <v-select
              :items="availableClients"
              v-model="selectedClientId"
              :disabled="(selectedServiceId || selectedContractorId) ? true : false"
              item-text="title"
              item-value="id"
              no-data-text="No clients"
              label="Clients"
              clearable
              @change="handleFilterChanged"
            />
          </v-flex>
        </v-layout>
        </v-container>
        <v-container fluid :style="{'padding-top': 0}">
          <v-layout>
            <table class="v-table theme--light">
              <thead>
              <tr>
                <th class="column text-xs-left">Client</th>
                <th class="column text-xs-left">Service</th>
                <th class="column text-xs-left">Effective Contractor</th>
              </tr>
              </thead>
              <tbody>
              <contractor-item-detail v-for="item in filteredItems"
                                  v-bind:key="item.id"
                                  v-bind:item="item">
              </contractor-item-detail>
              <tr v-if="filteredItems.length === 0">
                <td colspan="3" class="text-sm-center">Select Contractor or Service or Client to show details</td>
              </tr>
              </tbody>
            </table>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-flex>
  </div>
</template>

<script>
import ContractorItem from './ContractorItem'
import ContractorForm from './ContractorForm'
import ContractorItemDetail from './ContractorItemDetail'

export default {
  name: 'contractors',
  components: {
    ContractorItem,
    ContractorForm,
    ContractorItemDetail
  },
  props: {
    items: {
      type: Array
    },
    availableServices: {
      type: Array
    },
    availableClients: {
      type: Array
    },
    clientServicesByClientId: {
      type: Object
    }
  },
  data () {
    return {
      contractorFormVisible: false,
      selectedContractorItem: null,
      filteredItems: [],
      selectedServiceId: null,
      selectedClientId: null,
      selectedContractorId: null
    }
  },
  computed: {
    fullAvailableContractorsSet(){
      let fullSet = []
      let clientsId = _.keys(this.clientServicesByClientId)

      _.forOwn(clientsId, clientId => {
        _.forOwn(this.clientServicesByClientId[clientId], servicesOfClient => {
          let client = _.find(this.availableClients, c => c.id == servicesOfClient.clientId)
          let service = _.find(this.availableServices, c => c.id == servicesOfClient.serviceId)
          if (!service || !client) {
            return
          }

          let contractor = this.effectiveContractor(servicesOfClient.contractorId, client, service)
          if (contractor && contractor.effectiveContractorId){
            fullSet.push({
              ...servicesOfClient,
              ...contractor,
              serviceTitle: `(${service.code}) ${service.title}`,
              clientTitle: client.title
            })
          }
        })
      })

      return fullSet
    }
  },
  methods: {
    effectiveContractor(serviceClientContractorId, client, service){
      let contractor = _.find(this.items, c => c.id == serviceClientContractorId)
      if (contractor) {
        return {
          contractorTitle: contractor.title,
          contractorType: 'client-service',
          contractorFrom: 'Contractor from Service Of Client',
          effectiveContractorId: serviceClientContractorId,
        }
      }

      if (client){
        contractor = _.find(this.items, c => c.id == client.contractorId)
        if (contractor) {
          return {
          contractorTitle: contractor.title,
          contractorType: 'client',
          contractorFrom: 'Contractor from Client',
          effectiveContractorId: client.contractorId,
         }
        }
      }

      contractor = _.find(this.items, c => c.id == service.contractorId)
      if (contractor) {
        return {
          contractorTitle: contractor.title,
          contractorType: 'service',
          contractorFrom: 'Contractor from Service',
          effectiveContractorId: service.contractorId,
        }
      }
    },
    handleFilterChanged(){
      this.filteredItems = []
      if (!this.selectedServiceId && !this.selectedClientId && !this.selectedContractorId){
        return
      }
      
      _.forOwn(this.fullAvailableContractorsSet, service => {
        if((this.selectedServiceId && this.selectedServiceId == service.serviceId) ||
           (this.selectedClientId && this.selectedClientId == service.clientId) ||
           (this.selectedContractorId && this.selectedContractorId == service.effectiveContractorId)){
             this.filteredItems.push({
                ...service
             })
        }
      })
    },
    handleClickCreateContractorButton () {
      this.selectedContractorItem = null
      this.contractorFormVisible = !this.contractorFormVisible
    },
    handleCreationFormCloseEvent () {
      this.contractorFormVisible = false
    },
    handleContractorEditEvent (item) {
      this.selectedContractorItem = item
      this.contractorFormVisible = !this.contractorFormVisible
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Sales/Contractors.vue